import FacebookIcon from "@/App/Assets/Images/facebook.svg";
import InstagramIcon from "@/App/Assets/Images/instagram.svg";
import XIcon from "@/App/Assets/Images/x.svg";
import YoutubeIcon from "@/App/Assets/Images/youtube.svg";
import Textfield from "@/Components/Input/Textfield";
import { capitalizeFirstLetter } from "@/shared/utils/helpers";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

// Each url is stored at its index in social_media_urls, so the order matters
const brandIconUrls = {
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  x: XIcon,
  youtube: YoutubeIcon,
};

const SocialMedia = () => {
  const { t } = useTranslation("", { keyPrefix: "settings_page" });
  const { register } = useFormContext();

  return (
    <div data-tour="website-settings.social-media" className="mb-12">
      <h2> {t("socialMedia")}</h2>
      <div className="flex flex-col gap-2">
        {Object.entries(brandIconUrls).map(([name, iconUrl], index) => (
          <Textfield
            key={name}
            ref={register}
            name={`socialMediaUrls[${index}]`}
            placeholder={`${capitalizeFirstLetter(name)} url`}
            leftAddonPadding="0.25rem 1.5rem"
            inputLeftAddon={
              <img
                src={iconUrl}
                alt={`${name} icon`}
                style={{
                  width: "2.8rem",
                  height: "2.8rem",
                  objectFit: "fill",
                }}
              />
            }
          />
        ))}
      </div>
    </div>
  );
};

export default SocialMedia;
